import type { ConceptBrief } from "../concept/ConceptType";
import { ConceptApi } from "../concept/ConceptApi";

/** 观点页概念清单，复用 ConceptApi.listConcepts（sessionStorage 缓存 5 分钟） */
export async function listViewpointConceptCatalog(
  conceptSpaceProductId: string
): Promise<ConceptBrief[]> {
  return ConceptApi.listConcepts(conceptSpaceProductId);
}
